import { createContext, useContext, ReactNode } from 'react'

interface EmbedContextType {
  isEmbed: boolean
  basePath: string
  loginPath: string
}

const EmbedContext = createContext<EmbedContextType>({
  isEmbed: false,
  basePath: '/customer',
  loginPath: '/customer/login',
})

export function EmbedProvider({ children }: { children: ReactNode }) {
  return (
    <EmbedContext.Provider value={{ isEmbed: true, basePath: '/embed', loginPath: '/embed' }}>
      {children}
    </EmbedContext.Provider>
  )
}

export function useEmbed() {
  return useContext(EmbedContext)
}
